import { SerializedBusinessError } from 'shared/api/common/schemas/errors'

export interface FollowReplyNeedToUpdatePermissionsError extends SerializedBusinessError {
  field: 'need_update_permissions_for_follow_reply'
}

export const isFollowReplyNeedToUpdatePermissionsError = (
  error: SerializedBusinessError,
): error is FollowReplyNeedToUpdatePermissionsError => {
  return error.field === 'need_update_permissions_for_follow_reply'
}
